import React from 'react';
import './NotificationsPanel.css';

export default function VideoRecordingsPanel({ videos = [], onClose, onDelete }) {
  return (
    <div className="notifications-overlay" onClick={onClose}>
      <div
        className="notifications-panel"
        onClick={e => e.stopPropagation()}
      >
        <div className="notifications-header">
          <h3>Video Recordings</h3>
          <button onClick={onClose} className="close-btn">×</button>
        </div>
        <div className="notifications-content">
          {videos.length === 0 ? (
            <p>No video recordings available.</p>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {videos.map((video) => (
                <li key={video._id} style={{ marginBottom: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                  <strong>{video.title}</strong>
                  <p>{video.description}</p>
                  <small>
                    Uploaded: {new Date(video.uploadDate).toLocaleString()}<br />
                    Size: {(video.size / 1024 / 1024).toFixed(2)} MB<br />
                    {video.droneId && `Drone: ${video.droneId}`}
                  </small>
                  {video.filename && (
                    <div style={{ marginTop: '10px' }}>
                      <video controls key={video._id} style={{ maxWidth: '100%', height: '200px' }}>
                        <source src={`http://localhost:3001/uploads/${video.filename}`} type="video/mp4"/>
                      </video>
                    </div>
                  )}
                  <button 
                    onClick={() => onDelete(video._id)} 
                    style={{ marginTop: '10px', color: 'red', cursor: 'pointer' }}
                    className="delete-btn"
                  >
                    Delete
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}